import { nanoid } from 'nanoid';
import { IS_PUSHPIN_COMMENT_ACTIVE, OPEN_PUSHPIN_DETAIL, PushpinOpenType, REFRESH_PUSHPIN_DATA, SELECTED_COMMENTS_FOR_PUSHPIN } from '../actionTypes';
import { IPushpinOpenData } from '../stateTypes';

const initialState: IPushpinOpenData = {
  pushpinId: null,
  uniqueId: undefined,
};

export function pushpinReducer(
  state = initialState,
  action: PushpinOpenType
): IPushpinOpenData {
  if (action.type === OPEN_PUSHPIN_DETAIL) {
    return {...state, 
        uniqueId : action.payload.uniqueId,
        pushpinId : action.payload.pushpinId,
    };
  }
  if(action.type === IS_PUSHPIN_COMMENT_ACTIVE){
    return {...state, 
      isPushpinCommentActive: action.payload.isPushpinCommentActive,
      pushpinId: action.payload.pushpinId
    } as any;
  }
  if(action.type === SELECTED_COMMENTS_FOR_PUSHPIN){
    return {...state, 
      comments: action.payload.comments,
    } as any;
  }

  if(action.type === REFRESH_PUSHPIN_DATA){
    return { ...state, 
      refresh: nanoid(),
    } as any;
  }

  return state;
}